import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../hocs/layout/DashboardLayout";
import { Link } from "react-router-dom";
import { IconFilter, IconSearch } from "@tabler/icons-react";
import {
  get_inventario_list,
  get_inventario_list_page,
} from "../../../redux/actions/P03/p03";
import { connect } from "react-redux";
import InventarioList from "../../../components/P03/inventario/InventarioList";
import Toast from "../../../components/Alert";

function Inventario({
  get_inventario_list,
  get_inventario_list_page,
  inventario,
  count,
}) {
  const [producto, setProducto] = useState("");
  useEffect(() => {
    if (producto !== "") {
      get_inventario_list(producto);
    } else {
      get_inventario_list();
    }
  }, [producto, get_inventario_list]);

  const handleChangeProducto = (e) => {
    setProducto(e.target.value);
  };

  const [term, setTerm] = useState("");
  const handleChange = (e) => {
    setTerm(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setTimeout(() => (window.location.href = "/inventario-p03/" + term), 0.2);
    setTerm("");
  };

  const handleReporteCompleto = () => {
    if (producto) {
      setTimeout(() => {
        window.location.href = "/inventario-p03/ver-completo/" + producto;
      }, 0.2);
    } else {
      setTimeout(() => {
        window.location.href = "/inventario-p03/ver-completo/" + "all";
      }, 0.2);
    }
  };
  
  return (
    <DashboardLayout>
      <div className="border-b border-gray-200 py-5 sm:px-6 dark:border-gray-700">
        <div className="flex flex-col flex-wrap lg:flex-row lg:items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-2xl font-medium leading-6 text-gray-900 dark:text-white">
              Materiales y productos Planta 03.
            </h3>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 py-2 lg:py-0">
            <div className="flex items-center md:max-w-3xl md:mx-auto lg:max-w-none">
              <form onSubmit={(e) => onSubmit(e)} className="w-full">
                <label htmlFor="search" className="sr-only">
                  Search
                </label>
                <div className="relative">
                  <button
                    type="submit"
                    className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
                  >
                    <IconSearch stroke={"#0096C4"} />
                  </button>
                  <input
                    id="search"
                    name="search"
                    required
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    className="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Buscar"
                    type="search"
                  />
                </div>
              </form>
            </div>
            <div className="dropdown dropdown-end">
              <div
                tabIndex={0}
                role="button"
                className="p-1.5 bg-white border border-[#0096C4] rounded dark:bg-gray-700 dark:border-gray-600"
              >
                <IconFilter stroke="#0096C4" />
              </div>
              <div
                tabIndex={0}
                className="dropdown-content z-[1] menu p-4 shadow bg-base-100 rounded-box w-52 dark:bg-gray-800 dark:text-white"
              >
                <div className="flex flex-col gap-y-2">
                  <label className="form-control w-full max-w-xs">
                    <div className="label">
                      <span className="label-text dark:text-gray-300">
                        Producto
                      </span>
                    </div>
                    <select
                      onChange={handleChangeProducto}
                      value={producto}
                      className="select select-bordered w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    >
                      <option value="">Elige una opción</option>
                      <option value="Aceite">Aceite</option>
                      <option value="Aditivo">Aditivo</option>
                      <option value="Almidon">Almidon</option>
                      <option value="Asas">Asas</option>
                      <option value="Corrugado">Corrugado</option>
                      <option value="Disposiciones">Disposiciones</option>
                      <option value="Etiqueta">Etiqueta</option>
                      <option value="Envase">Envase</option>
                      <option value="Stickers">Stickers</option>
                      <option value="Tapas">Tapas</option>
                      <option value="Tapon">Tapon</option>
                    </select>
                  </label>

                  <button
                    onClick={handleReporteCompleto}
                    className="btn btn-primary"
                  >
                    Generar reporte completo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InventarioList
        inventario={inventario}
        count={count}
        get_inventario_list_page={get_inventario_list_page}
      />
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ({
  inventario: state.inventario.inventarios,
  count: state.inventario.count,
});

export default connect(mapStateToProps, {
  get_inventario_list,
  get_inventario_list_page,
})(Inventario);
